export default __webpack_public_path__ + "static/media/feature_2@3x.36bb79d8.png";